export default {
  login({ commit }, payload) {
    return commit("login", payload);
  },

  register({ commit }, payload) {
    return commit("register", payload);
  },

  logout({ commit }) {
    commit("logout");
  },

  updateInfo({ commit }, payload) {
    commit("updateInfo", payload);
  },

  changePassword({ commit }, payload) {
    return commit("changePassword", payload);
  },

  setIsDoneFalse({ commit }) {
    commit("setIsDoneFalse");
  },

  resetCase({ commit }) {
    commit("resetCase");
  },

  DSPGetCompanyInfo({ commit }) {
    return commit("DSPGetCompanyInfo");
  },
};